import { Permission } from '../security/permission';
import { Node } from '../base/node';
import { Branch } from '../base/branch';
import { Group } from './group';

export class User extends Node {
    static _type: string = 'User';

    i_user: true = true;

    token?: string;
    email?: string;
    roles?: string[];

    constructor(source?: any) {
        super(source);

        if (source) {
            this.token = source.token;
            this.email = source.email;
            this.roles = source.roles;
        }
    }

    copy(source?: any) {
        super.copy(source);

        if (source) {
            this.token = source.token;
            this.email = source.email;
            this.roles = source.roles;
        }
    }

    get valid(): boolean {
        return (this.token?.length ?? 0) > 0;
    }

    has<K extends keyof Permission>(permission: Permission, ...keys: K[]): boolean {
        return this._system || permission && !!keys?.some(key => !!permission[key]?.find(role => this.roles?.find(x => x === role)));
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Group;
    }
}
